import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section id="articles" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <div className="flex-1">
            <p className="text-xs font-semibold text-accent-500 uppercase tracking-wider mb-3">
              SEO Articles & Guides
            </p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              Latest <span className="text-primary-500">ACBuy Spreadsheet</span> Resources
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            Dive deeper with our collection of <strong>acbuy spreadsheet</strong> articles — covering everything from beginner tips to advanced shopping strategies for 2026.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.01] cursor-pointer border border-background-200/70"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={`ACBuySpreadsheet article: ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span
                  className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-[10px] font-semibold ${article.tagColor}`}
                >
                  {article.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-full text-[10px] font-medium bg-background-50/90 text-foreground-600 backdrop-blur-sm">
                  {article.readTime}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-foreground-900 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs font-semibold text-primary-500">
                  Read Article <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}